/**
 *
 * StudentTable
 *
 */
import React, { memo } from 'react';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';

interface Props {
  studentData: any;
}

const thClassNames = `px-4 py-3 max-w-[12mm] text-center text-md font-bold text-black uppercase tracking-wider border border-gray-300`;
const tdClassNames = `px-4 py-3 max-w-[12mm] border border-gray-300 text-center`;

export const StudentTable = memo((props: Props) => {
  const studentData = props?.studentData;

  
  React.useEffect(() => {
    // if (studentData)
    // window.print();
    return () => {
      EncryptedStorage.removeItem('STUDENT_DATA')
    }
  }, []);

  return (
    <div>
       <div className='flex justify-end p-4 print:hidden'>
          {!!studentData && <button className='bg-primary-main text-neutral-light px-4 py-1 rounded-lg' onClick={() => window.print()}>Print</button>}
        </div>
      <h1 className="text-2xl text-center font-bold mb-4 mt-3">Student Table</h1>
      <table className="min-w-full divide-y divide-black border border-black">
        <thead className="bg-gray-50">
          <tr>
            <th className={thClassNames}>S. No</th>
            <th className={thClassNames}>Student Name</th>
            <th className={thClassNames}>Class</th>
            <th className={thClassNames}>Roll Number</th>
            <th className={thClassNames}>Admission No</th>
            <th className={thClassNames}>Mobile No</th>
            <th className={thClassNames}>Parent Name</th>
            <th className={thClassNames}>Admission Date</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-black">
          {studentData.map((student, index) => (
            <tr key={student.STUDENT_ID}>
              <td className={tdClassNames}>{index + 1}</td>
              <td
                className={tdClassNames}
              >{`${student.FIRST_NAME} ${student.LAST_NAME}`}</td>
              <td className={tdClassNames}>
                {student?.StudentClass?.Class?.NAME}
              </td>
              <td className={tdClassNames}>
                {student?.StudentClass?.ROLL_NUMBER}
              </td>
              <td className={tdClassNames}>{student?.ADMISSION_NUMBER}</td>
              <td className={tdClassNames}>{student?.MOBILE_NUMBER}</td>
              <td className={tdClassNames}>
                {student?.Parent?.[0]?.FIRST_NAME}{' '}
                {student?.Parent?.[0]?.LAST_NAME}
              </td>
              <td className={tdClassNames}>{student?.ADMISSION_DATE}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});
